import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CountryRedirectService {
  // Optional fallback for language-based redirects (kept but empty by default)
  private readonly REDIRECT_URL = 'https://app.yaraplus.com/tankmix';

  // If you want language-based redirect too, add langs here (e.g., 'en', 'es')
  private readonly ALLOWED_LANGS = new Set<string>([
    // 'en', 'es'
  ]);

  // Exact URLs per country (ISO-2 lowercase)
  private readonly COUNTRY_URLS: Record<string, string> = {
    be: 'https://fr.yaraplus.be/tankmix/?utm_source=tankmix.com',
    de: 'https://yaraplus.de/tankmix/?utm_source=tankmix.com', 
    cz: 'https://www.yaraagri.cz/vyziva-rostlin/nastroje-sluzby/tankmix/?utm_source=tankmix.com&utm_term=cz',
    hu: 'https://www.yara.hu/tapanyagellatas/eszkozok/yaraplus-tankmix/?utm_source=tankmix.com',
    nl: 'https://yaraplus.nl/tankmix/?utm_source=tankmix.com',
    pl: 'https://www.yara.pl/odzywianie-roslin/narzedzia-i-uslugi/tankmix?utm_source=tankmix.com',
    ro: 'https://www.yara.ro/nutritia-plantelor/tools-and-services/tankmix/?utm_source=tankmix.com',
    sk: 'https://www.yaraagri.cz/vyziva-rostlin/nastroje-sluzby/tankmix/?utm_source=tankmix.com',
    ua: 'https://www.yara.ua/crop-nutrition/tools-and-services-landing-page/tankmix/?utm_source=tankmix.com',
    gb: 'https://app.yaraplus.com/',
    ie: 'https://app.yaraplus.com/',
    no: 'https://app.yaraplus.com/tankmix',
    se: 'https://app.yaraplus.com/tankmix',
    dk: 'https://app.yaraplus.com/tankmix',
    ee: 'https://app.yaraplus.com/tankmix',
    lv: 'https://app.yaraplus.com/tankmix',
    lt: 'https://app.yaraplus.com/tankmix'


  
  };

  /** Redirects if language is allowed OR country is in the list. Returns true if redirected. */
  redirectByLangOrCountry(
    language?: string | null,
    country?: string | null,
    opts?: { allowBypassQuery?: string; replace?: boolean, bypassPaths?: string[] }
  ): boolean {

    const allowBypass = opts?.allowBypassQuery ?? 'noredirect';
    if (new URLSearchParams(location.search).has(allowBypass)) return false;

     // Path bypass: /tankmix
      const currentPath = location.pathname.toLowerCase().replace(/\/+$/, '');
  // bypass redirect when user enters /tankmix
    if (currentPath.endsWith('/tankmix')) {
      return false;
    }

    const lang = language?.toLowerCase?.();
    const cc   = country?.toLowerCase?.();

    // Prefer country-specific URL if available
    const countryUrl = cc ? this.COUNTRY_URLS[cc] ?? null : null;

    // Otherwise fall back to language-based (only if you add langs above)
    const langAllowed = lang ? this.ALLOWED_LANGS.has(lang) : false;
    const fallbackUrl = langAllowed ? this.REDIRECT_URL : null;

    const dest = countryUrl || fallbackUrl;
    if (!dest) return false;

    if (location.href === dest) return false;

    (opts?.replace ?? true)
      ? location.replace(dest)
      : (location.href = dest);

    return true;
  }
}
